import { render } from "./BaseTableHeaderWidthFull.vue?vue&type=template&id=6bbbe945"
import script from "./BaseTableHeaderWidthFull.vue?vue&type=script&lang=js"
export * from "./BaseTableHeaderWidthFull.vue?vue&type=script&lang=js"

import exportComponent from "/Users/norman/Code/aerocle-project/aerocle_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__